import script from "./BodyBuildSectionDW5.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyBuildSectionDW5.vue?vue&type=script&setup=true&lang=js"

import "./BodyBuildSectionDW5.vue?vue&type=style&index=0&id=cd2dd268&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd2dd268"]])

export default __exports__